import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';
import Mensagem from '../../common/Mensagem'
import api from '../../services/api';
import './styles.css'

class Login extends Component {
    
    constructor(props){
        super(props);
        this.state = {
            nome:'',
            senha:'',
            carregar:false,
        }

        this.handleLogin = this.handleLogin.bind(this);
        this.handleRegistro = this.handleRegistro.bind(this);
    }

    async componentDidMount() {
        this.setState({
            nome:'',
            senha:'',
            carregar:false,
        })
    }

    handleLogin = async (event) => {
        
        event.preventDefault();
        this.setState({carregar:true})
        const { nome, senha } = this.state
        
        if( !nome && !senha ) {
            toast.error('O usuário e senha são obrigatórios.');
        } 
            
        
        try { 

            const response = await api.post('/api/login', {nome, senha});
            sessionStorage.setItem('id'       , response.data[0].id           );
            sessionStorage.setItem('usuario'  , response.data[0].usuario      );
            sessionStorage.setItem('token'    , response.data[0].token        );
            sessionStorage.setItem('pessoa'   , response.data[0].pessoa       );
            sessionStorage.setItem('pessoaid' , response.data[0].pessoaid     );
            sessionStorage.setItem('tipo'     , response.data[0].tipopessoa   );
            sessionStorage.setItem('grupo'    , response.data[0].grupo        );
            sessionStorage.setItem('empresaid', response.data[0].id        );
            sessionStorage.setItem('razao'    , response.data[0].razao        );
            this.setState({carregar:false})
            this.props.history.push('/index')    
            
        } catch (error) {
            console.log(error)
            this.setState({carregar:false})
            toast.error("O usuário e senha incorretos.") 
        }
    }
    
    handleRegistro = async (event) => {
        event.preventDefault();
        this.props.history.push('/registro');    
    }
    
    handleEsqueceu = async (event) => {
        event.preventDefault();
        this.props.history.push('/esqueceu');    
    }

    render() {

        return ( 
            <body className="hold-transition login-page" >
                <div className="card">
                    <div className="card-body login-card-body">
                        <div className="login-box">
                            <div className="login-logo">
                                    <a href="/login"><b>Ws</b>Lavanderia</a>
                            </div>
                        </div>
                
                        <p className="login-box-msg">Informe usuário e senha de acesso.</p>
                        <form onSubmit={this.handleLogin}>
                            <div className="input-group mb-3">
                                  
                                <input type="text" 
                                    className="form-control" 
                                    name="nome" 
                                    placeholder="Informe e-mail" 
                                    required="true"
                                    value={ this.state.nome } 
                                    onChange={ e => this.setState( { nome: e.target.value } )} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input type="password" 
                                    className="form-control" 
                                    name="senha" 
                                    placeholder="Informe Senha" 
                                    required="true"
                                    value={ this.state.senha } 
                                    onChange={ e => this.setState({ senha: e.target.value })}/>
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <button type="submit" className="btn btn-primary btn-block">Login</button>
                                </div>                                    
                            </div>
                        </form>      
                        <div className="input-group mb-1">
                            <Link onClick={ this.handleEsqueceu }>Esqueci minha senha</Link>
                        </div>
                        <div className="input-group mb-3">
                            <Link onClick={ this.handleRegistro } class="text-center">Registrar Novo Usuário</Link>
                        </div>                        
                    </div>
                    { this.state.carregar ? 
                        <div class="overlay d-flex justify-content-center align-items-center">
                            <i class="fas fa-2x fa-sync fa-spin"></i>
                        </div>
                        : ''
                    }                
                </div>
                <Mensagem />
            </body>
        )
    }
}

export default Login;